/**
 * Geometry shared by `QuickAccess`, `QuickAccessSkeleton` and the tiles that suspend on their own data.
 * These must stay identical across the three: the skeleton mirrors the real grid rather than approximating
 * one total height, because the rows reflow from 1 to 2 and from 2 to 4 columns at `md`, so a single
 * fixed-height block would be wrong at one of the two breakpoints. Nothing enforces that — jsdom has no
 * layout engine, so no test can catch a divergence — hence one source of truth.
 *
 * Tailwind scans `.ts` files for class strings, so the utilities below still generate from here.
 */

/** Height of a tile in the first row. Any `Suspense` fallback standing in for one must use this. */
export const LARGE_TILE_HEIGHT_PX = 128

/** Height of a tile in the second row. */
export const SMALL_TILE_HEIGHT_PX = 112

/**
 * Corner radius of a tile, for placeholders standing in for one — `Skeleton`'s `block` preset is
 * `rounded-20`, so without this its corners change shape at the swap. Kept as the token rather than its
 * px value because `--border-radius-30` is 12px under Orus but 8px under the `qonto` theme: a literal
 * would be right for one brand and wrong for the other. `Skeleton` takes any CSS length here, and its
 * `text` preset reads a raw token the same way (`h-[var(--leading-40)]`).
 */
export const TILE_RADIUS = 'var(--border-radius-30)'

export const QUICK_ACCESS_SECTION_CLASSNAME = 'flex flex-col gap-stack'

export const LARGE_TILE_GRID_CLASSNAME = 'grid grid-cols-1 gap-stack md:grid-cols-2'

export const SMALL_TILE_GRID_CLASSNAME = 'grid grid-cols-2 gap-stack md:grid-cols-4'
